import { CustomFormTemplate } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formTemplate: CustomFormTemplate;
}

interface ResponseDataType {
  template: CustomFormTemplate;
  is_company_can_enable_more_templates_available_in_offline: boolean;
}

export const updateCustomFormTemplateRequest = ({
                                                  token,
                                                  formTemplate,
                                                }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-template/${ formTemplate.id }`, {
    method: 'PUT',
    token,
    body: formTemplate,
  });
};